import { IconClock } from "@tabler/icons-react"
import { type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = { className?: string }

const AiGenerationDiscountNotice: FC<Props> = ({ className }) => (
	<div
		className={cn(
			"flex flex-col items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-amber-950 sm:flex-row sm:items-center",
			className,
		)}
	>
		<span className="flex shrink-0 items-center gap-1 rounded-full bg-amber-200 px-2 py-0.5 text-xs font-semibold">
			<IconClock className="size-3.5" aria-hidden="true" />
			Limited-time
		</span>
		<p className="text-sm">
			Forento AI is heavily discounted right now. Cost for Forento AI generations will increase when we launch
			open beta.
		</p>
	</div>
)

export default AiGenerationDiscountNotice
